export default __webpack_public_path__ + "static/media/successIcon.46563e52.png";